import config from "../config";
import TikTok from "../plugins/tiktokPlugin";
import { generateTikTokCodeVerifier, getPlatform } from "../utils";

export class TikTokService {
    constructor() {
        
    }

    async login() {
        const platform = getPlatform();
        return platform === 'web' ? await this.webLogin() : await this.nativeLogin();
    }

    private async nativeLogin () {
        const codeVerifier = generateTikTokCodeVerifier();
        const result = await TikTok.login({ clientKey: config.tiktok.clientKey, codeVerifier, redirectUri: config.tiktok.nativeRedirectUri });
        console.log('Response from tiktok:', result);
        return result.authCode + " " + codeVerifier
    }

    private async webLogin () {
        return new Promise(resolve => {
            const state = generateTikTokCodeVerifier();
            const authUrl = `${config.tiktok.webAuthEndpoint}?client_key=${config.tiktok.clientKey}&redirect_uri=${config.tiktok.webRedirectUri}&response_type=code&scope=user.info.basic&state=${state}`;
        
            const popup = window.open(authUrl, "TikTok Login", "width=500,height=600");

            let codePlusState = "";

            const messageHandler = async (event: MessageEvent<any>) => {
                if(event.origin !== window.location.origin) return;

                if(!event.data.code) return;

                console.log("Authorization Code for tiktok:", event.data.code);
                const authorizationCode = event.data.code;
                codePlusState = authorizationCode + " " + state;
            }
        
            window.addEventListener("message", messageHandler);

            const popupCheck = setInterval(() => {
                if (popup?.closed) {
                    clearInterval(popupCheck);
                    window.removeEventListener("message", messageHandler);
                    resolve(codePlusState);
                }
            }, 1000);
        })
    }
}